var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightRectangeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 751.741,
    height: 780.557,
    viewBox: "0 0 751.741 780.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.075,
    y1: -0.163,
    x2: 0.861,
    y2: 1.173,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#080807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070707"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "right-rectange-dark",
    width: 621.86,
    height: 573.648,
    rx: 191,
    transform: "translate(751.741 196.199) rotate(110)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRectangeDark);
export default __webpack_public_path__ + "static/media/right-rectange-dark.1aa738a55a59aa3d3cb295255421e3fa.svg";
export { ForwardRef as ReactComponent };